import { createThunkEffect } from "../../utilities/ActionUtility";
import { IBusinessPartner } from "../../views/components/BusinessPartnersTextField/BusinessPartnersTextField";
import * as BusinessPartnerEffect from "./BusinessPartnerEffect";

// business partners
export const REQUEST_ALL_BUSINESS_PARTNERS = "BusinessPartnerEffect.REQUEST_ALL_BUSINESS_PARTNERS";
export const REQUEST_ALL_BUSINESS_PARTNERS_FINISHED = "BusinessPartnerEffect.REQUEST_ALL_BUSINESS_PARTNERS_FINISHED";

export function requestAllBusinessPartners() {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_ALL_BUSINESS_PARTNERS, BusinessPartnerEffect.requestAllBusinessPartners);
    };
}

export const REQUEST_ADD_BUSINESS_PARTNER = "BusinessPartnerEffect.REQUEST_ADD_BUSINESS_PARTNER";
export const REQUEST_ADD_BUSINESS_PARTNER_FINISHED = "BusinessPartnerEffect.REQUEST_ADD_BUSINESS_PARTNER_FINISHED";

export function addOrEditBusinessPartner(id: number, businessPartner: IBusinessPartner) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_ADD_BUSINESS_PARTNER, BusinessPartnerEffect.addOrEditBusinessPartner, id, businessPartner);
    };
}

export const REQUEST_IMPORT_BUSINESS_PARTNERS = "BusinessPartnerEffect.REQUEST_IMPORT_BUSINESS_PARTNERS";
export const REQUEST_IMPORT_BUSINESS_PARTNERS_FINISHED = "BusinessPartnerEffect.REQUEST_IMPORT_BUSINESS_PARTNERS_FINISHED";

export function importBusinessPartners(businessPartners: IBusinessPartner[]) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_IMPORT_BUSINESS_PARTNERS, BusinessPartnerEffect.importBusinessPartners, businessPartners);
    };
}

export const REQUEST_DELETE_BUSINESS_PARTNER = "BusinessPartnerEffect.REQUEST_DELETE_BUSINESS_PARTNER";
export const REQUEST_DELETE_BUSINESS_PARTNER_FINISHED = "BusinessPartnerEffect.REQUEST_DELETE_BUSINESS_PARTNER_FINISHED";

export function deleteBusinessPartner(id: number) {
    return async(dispatch) => {
        await createThunkEffect(dispatch, REQUEST_DELETE_BUSINESS_PARTNER, BusinessPartnerEffect.deleteBusinessPartner, id);
    };
}